import {ReloadManager} from '../reloadManager';

export class Vvl {
    private readonly viewRoot: HTMLElement;
    constructor(viewRoot: HTMLElement) {
        this.viewRoot = viewRoot;
        this.registerEventListeners();
    }
    // vvl auszahlung / smartphone
    private registerEventListeners() {
        this.viewRoot.querySelectorAll('li.cmsReloadModuleVVL input').forEach((element) => {
            element.addEventListener('change', (event) => {
                const reloadManager = new ReloadManager();
                reloadManager.cmsReloadModule(event, true, false);
            });
        });
    }
}
